import React, { useRef } from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { alphaNumeric, alphaNumericspace, isValidEmail, onlyNumeric, generatePDF, formatDate } from '../../../commonClass/CommonValidation';
import validator from 'validator';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../../_actions/loader.actions";
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import CustomSelection from '../../../../customControl/CustomSelection';
import { ExportExcel } from '../../../commonClass/ExportExcel';
import CustomTable from '../../../../customControl/CustomTable';
import CommonFilter from '../../../../customControl/CommonFilter';

const AccesspointmasterAirport = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formErrors, setFormError] = useState({});
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [disabled, setDisabled] = useState();
    const [airportdata, setAirportData] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [useredit, setUserEdit] = useState(true);
    const [useradd, setUserAdd] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const [citydisable, setCityDisable] = useState(false);
    const user = useSelector(store => store.userstatus.tba);
    const [allCity, setallCity] = useState([]);
    const [citydata, setCityData] = useState([]);
    const [alllocation, setAllLocation] = useState([]);
    const [form, setForm] = useState({
        AccessPointAirportId: 0,
        LocationId: 0,
        AirportName: '',
        IATACode: '',
        Latitude: '',
        Longitude: '',
        EmailId: '',
        MobNoCode: '',
        MobNo: '',
        Address: '',
        Pincode: '',
        LandlineNoCode: '',
        LandlineNo: '',
        WebsiteURL: '',
        IsActive: false,
        UserId: 0
    });

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            form.IsActive = e
            setFormError({});
        }
        else {
            setModalShow(true);
        }
    }
    const handleConfirmation = (e) => {
        if (e === true) {
            form.IsActive = !form?.IsActive
            setEditDisabled(true);
            setFormError({});
        }
        setModalShow(false);
    }
    //#region bind datatable
    const columns = [
        {
            name: 'Airport Name',
            key: 'AirportName',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Airport) => Airport?.AirportName
        },
        {
            name: 'IATA Code',
            key: 'IATACode',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Airport) => Airport?.IATACode
        },
        {
            name: 'Latitude/Longitude',
            key: "letlong",
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Airport) => Airport?.letlong
        },
        {
            name: 'City',
            key: "City",
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Airport) => Airport?.City
        },
        {
            name: 'State',
            key: "StateName",
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Airport) => Airport?.StateName
        },

        {
            name: 'Active',
            key: 'Active',
            sortable: true,
            float: "left",
            selector: (Airport) => Airport?.Active
        },
        {
            name: 'Created Date',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Airport) => new Date(Airport?.CreatedOn),
            format: (Airport) => formatDate(Airport?.CreatedOn),
        },
        {
            name: 'Edit',
            selector: (Airport) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditMode(Airport?.AccessPointAirportId)}></i></button>
        },
        {
            name: 'View',
            selector: (Airport) => <i className="fa fa-eye" onClick={() => handleViewMode(Airport?.AccessPointAirportId)}></i>
        }
    ];

    function PdfExport() {
        const columns = [
            "Airport Name",
            "IATA Code",
            "Latitude",
            "Longitude",
            "City",
            "State",
            "Active",
            "Created Date"
        ];
        var rows = [];

        for (let i = 0; i < airportdata?.length; i++) {
            var temp = [
                airportdata[i]?.AirportName,
                airportdata[i]?.IATACode,
                airportdata[i]?.Latitude,
                airportdata[i]?.Longitude,
                airportdata[i]?.City,
                airportdata[i]?.StateName,
                `${airportdata[i]?.IsActive ? 'Active' : 'InActive'}`,
                formatDate(airportdata[i]?.CreatedOn)
            ];
            rows = [...rows, temp]
        }
        generatePDF(columns, rows, "AirPort", "Airport")
    };

    const ExportToExcel = () => {
        const displayname = [
            "Airport Name",
            "IATA Code",
            "Latitude",
            "Longitude",
            "City",
            "State",
            "Active",
            "Created Date"
        ];
        const fields = ['AirportName', 'IATACode', 'Latitude', 'Longitude', 'City', 'StateName', 'IsActive', 'CreatedOn'];
        ExportExcel(displayname, fields, airportdata, 'AirPort', 'AirPort.xls')
    }
    //#endregion

    //#region handling search

    useEffect(() => {
        getAirportlist();
        getcitylist();
    }, []);

    useEffect(() => {
        if (window?.location?.pathname !== '/dashboard') {
            let pagelink = user?.find(x => {
                if (x.PageLink === window?.location?.pathname)
                    return x.MenuId
            });
            let mid = user?.find(x => x.MenuId === pagelink?.MenuId);
            if (mid?.URightView === false && mid?.URightView !== undefined) {
                navigate('/dashboard');
            }
            user?.filter(x => x.MenuId === pagelink?.MenuId)?.map((obj) => {
                setUserAdd(obj?.URightAdd);
                setUserEdit(obj?.URightEdit);
                setUserExport(obj?.URightExport);
            });
        }
    }, [user])
    //#endregion

    const getAirportlist = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            await getAllData('/master/v1/getallaccesspointairport')?.then((airportdata) => {
                if (airportdata?.status) {
                    airportdata?.data?.map((obj) => {
                        obj.letlong = (obj?.Latitude + '/' + obj?.Longitude)
                        obj.Active = obj?.IsActive === true ? "Active" : "InActive"
                    })
                    setAirportData(airportdata?.data);
                    setFilterList(airportdata?.data)
                }
            });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const LocationId = useRef(null);

    const getcitylist = async () => {
        await getAllData('/master/v1/getallcity')?.then((airportdata) => {
            setallCity(airportdata?.data);
            setCityData(airportdata?.data?.filter(IsAct => IsAct.IsActive === true));
            dispatch(loaderActions.end());
        });
    }
    const cityList = citydata?.map(value => ({
        label: value.City,
        value: value.LocationId
    }));

    const getalllocationbyCity = async (locationid) => {
        await postUsersData('/master/v1/getlocationbyid', { LocationId: locationid })?.then((AllLocationData) => {
            setAllLocation(AllLocationData.data);
        });
    }

    const continent = alllocation?.map(value => ({
        label: value.continentName,
        value: 1
    }));

    const country = alllocation?.map(value => ({
        label: value.countryName,
        value: 1
    }));

    const region = alllocation?.map(value => ({
        label: value.regionName,
        value: 1
    }));

    const state = alllocation?.map(value => ({
        label: value.stateName,
        value: 1
    }));

    const handleEditMode = (id) => {
        setDisabled(false);
        setButtonAddEditText("Update");
        setSerachDisabled(true);
        RetriveData(id);
        setEditDisabled(false);
    }

    const handleViewMode = (id) => {
        setDisabled(true);
        setEditDisabled(false);
        setSerachDisabled(true);
        RetriveData(id);
    }

    const RetriveData = (id) => {
        setFormError({});
        airportdata?.map(obj => {
            if (obj.AccessPointAirportId === id) {
                form.AccessPointAirportId = obj.AccessPointAirportId
                form.LocationId = obj.LocationId
                form.AirportName = obj.AirportName
                form.IATACode = obj.IATACode
                form.Latitude = obj.Latitude
                form.Longitude = obj.Longitude
                form.EmailId = obj.EmailId
                form.MobNoCode = obj.MobNoCode
                form.MobNo = obj.MobNo
                form.Address = obj.Address
                form.Pincode = obj.Pincode
                form.LandlineNoCode = obj.LandlineNoCode
                form.LandlineNo = obj.LandlineNo
                form.WebsiteURL = obj.WebsiteURL
                form.IsActive = obj.IsActive
                // Check In-Active Data and add in Dropdown...
                let allcitylist = allCity?.filter(IsAct => IsAct.IsActive === true);
                setCityData(allCity?.filter(IsAct => IsAct.IsActive === true));
                setCityDisable(false);
                if (!allcitylist?.find(IsCity => IsCity.LocationId === obj.LocationId)) {
                    setCityDisable(true)
                    setCityData((prvCityData) => prvCityData?.length > 0 ? [...prvCityData, allCity?.find(isCity => isCity.LocationId === obj.LocationId)] : [])

                }
                getalllocationbyCity(obj.LocationId);
            }
        });

    }
    const handlecity = (e) => {
        form.LocationId = e.value
        getalllocationbyCity(e.value);
        setFormError({});
        setEditDisabled(true);
    }
    const validateData = () => {
        let status = true;
        let error = {};
        if (form?.LocationId === 0) {
            error.LocationId = "Kindly select the City name";
            status = false;
        }
        if (!form?.AirportName || form?.AirportName?.trim()?.length === 0) {
            error.AirportName = "Kindly Enter The Airport Name";
            status = false;
        }
        if (form?.EmailId?.trim()?.length > 0 && !isValidEmail(form?.EmailId)) {
            error.EmailId = "Email id should in a format abc@xyz.com";
            status = false;
        }
        if (form?.WebsiteURL?.length > 0 && !validator.isURL(form?.WebsiteURL)) {
            if (!validator.isURL(form?.WebsiteURL)) {
                error.WebsiteURL = "Only website links can be added here.";
                status = false;
            }
        }
        if (Object.keys(error)?.length > 0) {
            let id = Object.keys(error)[0];
            document.getElementById(id)?.focus();
            console.log("document.getElementById(id", document.getElementById(id))
        }
        setFormError(error)
        return status;
    }

    const handleSubmitData = async () => {
        if (validateData()) {
            let statusoftoken = await verifytoken();
            if (buttonaddeditText === 'Add') {
                if (statusoftoken) {
                    let user = GetLocalStorage()
                    form.UserId = user?.userMasterID
                    const Airportdata = await postUsersData('/master/v1/insertaccesspointairport', form)
                    const status = Airportdata.status;
                    if (!Airportdata.status && !Airportdata.data) {
                        dispatch({ type: 'ALERTING', message: Airportdata.message });
                        setDisabled(false);
                        setEditDisabled(true);
                        return;
                    }
                    if (status) {
                        dispatch({ type: 'ALERTING', message: Airportdata.message });
                        getAirportlist();
                        handleClearClick();
                        setDisabled(false);
                        setEditDisabled(true);
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: Airportdata.message })
                        setDisabled(false);
                        setEditDisabled(true);
                        return;
                    }
                }
                else {
                    ClearLocalStorage();
                    dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                }
            }
            else {
                if (statusoftoken) {
                    let user = GetLocalStorage()
                    form.UserId = user?.userMasterID
                    const Airportdata = await patchUsersData('/master/v1/updateaccesspointairport', form)
                    const status = Airportdata.status;
                    if (!Airportdata.status && !Airportdata.data) {
                        dispatch({ type: 'ALERTING', message: Airportdata.message });
                        setDisabled(false);
                        setEditDisabled(true);
                        return;
                    }
                    if (status) {
                        dispatch({ type: 'ALERTING', message: Airportdata.message });
                        getAirportlist();
                        handleClearClick();
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: Airportdata.message })
                        setDisabled(false);
                        setEditDisabled(true);
                        return;
                    }
                }
                else {
                    ClearLocalStorage();
                    dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                }
            }
        }
    }

    const onChange = (e) => {
        var result;
        if ([e.target.name][0] === 'MobNo') {
            result = onlyNumeric(e.target.value)
        }
        else if ([e.target.name][0] === 'AirportName') {
            result = alphaNumericspace(e.target.value)
        }
        else if ([e.target.name][0] === 'IATACode') {
            result = alphaNumeric(e.target.value)
        }
        else {
            result = e.target.value;
        }
        setForm({ ...form, [e.target.name]: result });
        setEditDisabled(true);
        setFormError({});
    }

    const handleClearClick = () => {
        setButtonAddEditText('Add');
        setDisabled(false);
        setFormError({});
        setForm({
            ...form,
            AirportName: '',
            IATACode: '',
            LocationId: 0,
            Latitude: '',
            Longitude: '',
            EmailId: '',
            MobNoCode: '',
            IsActive: false,
            AccessPointAirportId: 0,
            MobNo: '',
            Address: '',
            Pincode: '',
            LandlineNoCode: '',
            LandlineNo: '',
            WebsiteURL: ''
        });
        setAllLocation([]);
        getcitylist();
        getAirportlist();
        setCityDisable(false);
        setCityData([]);
        setEditDisabled(true);
        setSerachDisabled(false);
        setSerachBy('All');
        setSearchValue('');
    }
    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [searchDisabled, setSerachDisabled] = useState(false);
    //#endregion


    return (
        <>
            <div class="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div class="mb-3 row mx-1">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="row">
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">Continent</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={continent?.find(({ value }) => value === 1)}
                                            options={continent}
                                        />
                                    </div>

                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">Country</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={country?.find(({ value }) => value === 1)}
                                            options={country}
                                        />
                                    </div>

                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">Region</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={region?.find(({ value }) => value === 1)}
                                            options={region}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">State</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={state?.find(({ value }) => value === 1)}
                                            options={state}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">City</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <CustomSelection
                                            datalist={cityList}
                                            inputId='LocationId'
                                            selRef={LocationId}
                                            fieldid={form?.LocationId}
                                            SelectionChange={handlecity}
                                            isdisable={disabled}
                                            isactivedisable={citydisable}
                                            issearchable={true}
                                        />
                                        {formErrors.LocationId && <p className='text-danger text-start'>{formErrors.LocationId}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-1 mt-4 col-lg-11 mx-lg-5">
                        <div className='row'>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label required">Airport Name</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='AirportName'
                                            name="AirportName"
                                            value={form.AirportName}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Airport Name'
                                            maxLength={200}
                                        />
                                        {formErrors.AirportName && <p className='text-danger text-start'>{formErrors.AirportName}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">IATA Code</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='IATACode'
                                            name="IATACode"
                                            value={form.IATACode}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='IATA Code'
                                            maxLength={50}
                                        />
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Latitude</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='Latitude'
                                            name="Latitude"
                                            value={form.Latitude}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Latitude'
                                            maxLength={20}
                                        />
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Longitude</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='Longitude'
                                            name="Longitude"
                                            value={form.Longitude}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Longitude'
                                            maxLength={20}
                                        />
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Email Id</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='EmailId'
                                            name="EmailId"
                                            value={form.EmailId}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Email Id'
                                            maxLength={70}
                                        />
                                        {formErrors.EmailId && <p className='text-danger text-start'>{formErrors.EmailId}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Landline Number</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <div className='input-group'>
                                            <input class="form-control"
                                                type="text"
                                                id='LandlineNoCode'
                                                name="LandlineNoCode"
                                                value={form.LandlineNoCode}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Code'
                                                maxLength={6}
                                            />
                                            <input class="form-control"
                                                type="text"
                                                id='LandlineNo'
                                                name="LandlineNo"
                                                value={form.LandlineNo}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Landline Number'
                                                maxLength={15}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Mobile Number</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <div className='input-group'>
                                            <input class="form-control"
                                                type="text"
                                                id='MobNoCode'
                                                name="MobNoCode"
                                                value={form.MobNoCode}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Code'
                                                maxLength={6}
                                            />
                                            <input class="form-control"
                                                type="text"
                                                id='MobNo'
                                                name="MobNo"
                                                value={form.MobNo}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Mobile Number'
                                                maxLength={15}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Website URL</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='WebsiteURL'
                                            name="WebsiteURL"
                                            value={form.WebsiteURL}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Website URL'
                                        />
                                        {formErrors.WebsiteURL && <p className='text-danger text-start'>{formErrors.WebsiteURL}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Pincode</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input type="text"
                                            id="Pincode"
                                            class="form-control"
                                            name="Pincode"
                                            value={form.Pincode}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            maxLength={15}
                                            placeholder='Pincode' />
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-12 col-sm-12 '>
                                <div className='row'>
                                    <div class="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Address</label>
                                    </div>
                                    <div class=" col-lg-9 col-md-12 col-sm-12 mb-lg-1 mb-md-2">
                                        <textarea class="form-control"
                                            id="textAreaExample3"
                                            rows="2"
                                            name="Address"
                                            value={form.Address}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            placeholder='Address'
                                            maxLength={300}
                                        >
                                        </textarea>
                                    </div>

                                </div>
                            </div>
                            <div class="col-lg-12 col-sm-12">
                                <div class='row'>
                                    <div class="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Active</label>
                                    </div>
                                    <div class=" col-lg-9 col-md-12 col-sm-12 mb-lg-1 mb-md-2">
                                        <Switch
                                            onChange={handleisActive}
                                            checked={form?.IsActive}
                                            className="react-switch"
                                            disabled={disabled ? true : false}
                                        />
                                    </div>
                                    <ConfirmationModal
                                        show={modalShow}
                                        onHide={() => setModalShow(false)}
                                        noconfirm={() => handleConfirmation(false)}
                                        yesconfirm={() => handleConfirmation(true)}
                                    />

                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3 d-flex justify-content-center">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={handleSubmitData} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={handleSubmitData} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" class="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
                    </div>
                    <CommonFilter
                        columns={columns}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={getAirportlist}
                        setlistdata={setAirportData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={airportdata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default AccesspointmasterAirport